export { default as OfferIcons } from './OfferIcons';
